import { Box } from "@mui/material";
import { useState } from "react";
import { Navigate } from "react-router-dom";

import SalesMenuIndex from "../features/salesmanagement/Sales-Menu";
import DispatchList from "../features/salesmanagement/despatchplan/dispatchList";
import DeliveryOrderList from "../features/salesmanagement/deliveryOrder/deliveryOrderList";
import InvoiceList from "../features/salesmanagement/invoice/invoiceList";
import SaleOrderReports from "../features/reports/salesManagement/salesReportIndex";
import ReportTemplates from "../features/ordermanagement/reports/ReportTemplates";
import BackupInvoice from "../features/salesmanagement/invoice/BackupInvoice";
import DespatchListN from "../features/salesmanagement/despatch-plan.jsx/DespatchList";

const SalesDashboard = () => {
    const [activePage, setActivePage] = useState('ViewMainPage');

    const SetActive = (page) => {
        setActivePage(page);
    }

    const handleBackWinderMachineEntry = () => {
        setActivePage('ViewMainPage');
    }
    const handleBackDashboard = () => {
        Navigate("/");
    }
    return (
        <Box position="relative">

            {activePage === "ViewMainPage" && (<SalesMenuIndex
                SetActive={SetActive} handleBackDashboard={handleBackDashboard}
            />)}

            {/* {activePage === "Despatch Plan" && (
                <DespatchPlanManagement handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}
            {/* {activePage === "Despatch List" && (
                <DispatchPlan handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {/* 
            {activePage === "Delivery Order" && (
                <DeliveryOrderManagement handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "Invoice" && (
                <InvoiceManagement handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {/* {activePage === "SalesReports" && (
                <Reports handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {activePage === "Despatch List" && (
                <DispatchList handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} 

            {/* {activePage === "Despatch List" && (
                <DespatchListN handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}


            {activePage === "Delivery Order List" && (
                <DeliveryOrderList handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "Invoice List" && (
                <InvoiceList handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
                //    <BackupInvoice handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "SalesReports" && (
                <SaleOrderReports handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "ReportTemplates" && (
                <ReportTemplates handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

        </Box>

    );

};
export default SalesDashboard;